import React from 'react';

const WhoSection = () => (
  <section className="who" data-testid="who-section">
    <div className="wrap who-grid">
      <div className="head" style={{ marginBottom: 0 }}>
        <span className="eyebrow">Who we work with</span>
        <h2>Where there is a real accommodation need.</h2>
        <p>Every arrangement begins with a requirement someone can name: the people, the place, the length of stay and the standard.</p>
      </div>
      <div>
        <ul className="who-list">
          <li>Councils and local authorities</li>
          <li>Housing providers</li>
          <li>Care and supported-living providers</li>
          <li>Charities</li>
          <li>Employers and contractors</li>
          <li>Landlords and investors</li>
        </ul>
        <p className="where">Based in <b>Edinburgh</b> &middot; building across the United Kingdom</p>
      </div>
    </div>
  </section>
);

export default WhoSection;
